// 공종 템플릿 탭 — 템플릿 여러 벌과 공종 목록은 설정 뷰가 읽어 넘긴다.

import SettingsTemplatePanel, { TemplateTradeOption } from "@/modules/org/ui/settings-template-panel";
import { TradeTemplate } from "@buildpy/core/modules/template/types";

interface Props {
  canEdit: boolean;
  templates: TradeTemplate[];
  trades: TemplateTradeOption[];
}

const SettingsTemplate = ({ canEdit, templates, trades }: Props) => (
  <SettingsTemplatePanel canEdit={canEdit} templates={templates} trades={trades} />
);

export default SettingsTemplate;
